import * as React from 'react'

export const ItalicIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19.9286 6.35596V2.69971H8.14294V6.35596H11.5231L8.15708 18.5435H3.42865V22.1997H15.2144V18.5435H11.8342L15.2002 6.35596H19.9286Z'
        fill='currentColor'
      />
    </svg>
  )
})

ItalicIcon.displayName = 'ItalicIcon'
